import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset scroll position between route changes —
 * it's a client-side navigation, not a real page load, so the browser
 * has no reason to scroll anywhere on its own. Without this, clicking
 * a nav link while scrolled halfway down one page lands you at that
 * same scroll position on the next page, which reads as broken.
 *
 * Render this once, inside the Router but outside/alongside Routes —
 * it has no visual output of its own.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Unlike a traditional page load, a client-side route change in
      // React Router does NOT make the browser auto-scroll to a #hash
      // target on its own — that native behavior only fires on a real
      // document load. So this has to be done manually here, or a
      // link like "/platform#scoring" would land at the top of
      // Platform instead of at the Scoring section.
      const el = document.getElementById(hash.slice(1));
      el?.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}